import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, finalize } from 'rxjs';
import {
  CheckoutDeliveryAddressRQ,
  CheckoutInitRQ,
  PaymentMethodSelectedRQ,
  ShippingMethodSelectedRQ,
} from '../dto/request/checkout.rerquest';
import {
  CheckoutCompletedResponse,
  CheckoutResponse,
  PaypalIntentResponse,
  StripeIntentResponse,
} from '../dto/response/checkout.response';
import { PaymentMethodConfig } from '../dto/response/site.settings';

@Injectable({
  providedIn: 'root',
})
export class CheckoutService {
  private _loading = new BehaviorSubject<boolean>(false);
  loading$ = this._loading.asObservable();

  constructor(private http: HttpClient) {}

  initCheckout(initCheckout: CheckoutInitRQ) {
    this._loading.next(true);
    return this.http
      .post<CheckoutResponse>(
        `${environment.baseURL}${environment.CHECKOUT}/init`,
        initCheckout,
      )
      .pipe(
        finalize(() => {
          this._loading.next(false);
        }),
      );
  }

  setShippingAdress(
    checkoutId: string,
    shippingAddress: CheckoutDeliveryAddressRQ,
  ) {
    this._loading.next(true);
    return this.http
      .patch<CheckoutResponse>(
        `${environment.baseURL}${environment.CHECKOUT}/` +
          checkoutId +
          `/v2/delivery-address`,
        shippingAddress,
      )
      .pipe(
        finalize(() => {
          this._loading.next(false);
        }),
      );
  }

  selectShippingMethod(
    checkoutId: string,
    shippingMethod: ShippingMethodSelectedRQ,
  ) {
    this._loading.next(true);
    return this.http
      .patch<CheckoutResponse>(
        `${environment.baseURL}${environment.CHECKOUT}/` +
          checkoutId +
          `/shipping-method`,
        shippingMethod,
      )
      .pipe(
        finalize(() => {
          this._loading.next(false);
        }),
      );
  }

  selectPaymentMethod(
    checkoutId: string,
    paymentMethod: PaymentMethodSelectedRQ,
  ) {
    this._loading.next(true);
    return this.http
      .patch<CheckoutResponse>(
        `${environment.baseURL}${environment.CHECKOUT}/` +
          checkoutId +
          `/payment-method`,
        paymentMethod,
      )
      .pipe(
        finalize(() => {
          this._loading.next(false);
        }),
      );
  }

  getPaymentName(
    id: string,
    allPaymentMethods: PaymentMethodConfig,
  ): string | undefined {
    if (allPaymentMethods) {
      return allPaymentMethods.all.find((x) => x.id === id)?.platform;
    }
  }

  getPaymentPaypalIntent(
    checkoutId: string,
    paymentMethodId: string | undefined,
    successUrl: string,
    cancelUrl: string,
  ) {
    const queryParams = new HttpParams()
      // Añade "param1=value1"
      .set('successUrl', successUrl)
      .set('cancelUrl', cancelUrl);

    return this.http
      .get<PaypalIntentResponse>(
        `${environment.baseURL}${environment.CHECKOUT}/` +
          checkoutId +
          `/paypal-payment-intent/` +
          paymentMethodId,
        { params: queryParams },
      )
      .pipe(finalize(() => {}));
  }

  getPaymentStripeIntent(
    checkoutId: string,
    paymentMethodId: string | undefined,
  ) {
    return this.http
      .get<StripeIntentResponse>(
        `${environment.baseURL}${environment.CHECKOUT}/` +
          checkoutId +
          `/stripe-payment-intent/` +
          paymentMethodId,
      )
      .pipe(finalize(() => {}));
  }

  confirm(checkoutId: string) {
    this._loading.next(true);
    return this.http
      .post<CheckoutCompletedResponse>(
        `${environment.baseURL}${environment.CHECKOUT}/` +
          checkoutId +
          `/confirm`,
        {},
      )
      .pipe(
        finalize(() => {
          this._loading.next(false);
        }),
      );
  }
}
